<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <UsersTable title="Admins"></UsersTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UsersTable from "./Tables/UsersTable";
export default {
  name: "Admins",
  components: {
    UsersTable,
  },
};
</script>
<style></style>
